export default __webpack_public_path__ + "static/media/pendingbank.c849e532.svg";